import React from "react";
import ButtonTransitionIntoCalc from "./ButtonForCalc";

const CaseCard = ( {data} ) => {
    return(
        <>
            {
                
                    <div  className="relative flex flex-col justify-between rounded-3xl bg-no-repeat bg-cover 
                             md:p-5 p-2  overflow-hidden lg:h-[652px] md:h-[589px] h-[489px]" 
                            style={{backgroundImage: `url("${data.bg_img}")`}} 
                        >
                        <div className="absolute inset-0 opacity-40" style={{ backgroundColor: data.bg_color_casecard }}></div>
                        <button className="flex relative group secondary-custom-return-button items-center 
                                justify-center rounded-full md:w-12 md:h-12 w-8 h-8 z-10 aspect-square" 
                                onClick={() => window.location.replace(data.return_button.url_source)}
                            >
                            <img src={data.return_button.arrow_default} alt="" 
                                className="absolute md:p-0 p-2 transition-opacity duration-500 ease-linear opacity-100 group-hover:opacity-0"
                            />
                            <img src={data.return_button.arrow_hover_active} alt="" 
                                className="absolute md:p-0 p-2 transition-opacity duration-500 ease-linear opacity-0 group-hover:opacity-100 
                                rotate-180"
                            />
                        </button>
                        <div className="flex md:flex-row flex-col justify-between md:items-end  z-10 md:gap-12 h-full md:pt-0 pt-10 md:w-full ">
                            <span className="lg:text-[48px] md:text-[40px] text-[32px] font-medium text-pretty leading-tight w-[90%]" style={{color: data.description_color}}>
                                {data.description}
                            </span>
                            <ButtonTransitionIntoCalc data = {data}/>
                        </div>
                    </div>
            
            }
        </>
    );
};

export default CaseCard;